import React from 'react'
// libs
import { useShowModal } from 'hooks/useShowModal'
// constants
import { Modals } from 'constants/index'
// components
import { TrashIcon } from 'components/UI'
import { ColorSelect, ReduxInput, ReduxSelect } from 'components/FormElements'
// views
import {
  AddButton,
  Scrollbar,
  ColorWrapper,
  InputWrapper,
  OptionWrapper,
  SelectsWrapper,
  ColorPickerWrapper
} from './views'
// themes
import { colors } from 'themes/index'
// types
import { IOption } from 'components/FormElements/Select'
import { WrappedFieldArrayProps } from 'redux-form/lib/FieldArray'
// utils
import { v4 as uuid } from 'uuid'
import { required } from 'utils/validators'

export const COMPARISON_OPTIONS = [
  { label: 'Greater than', value: 'GREATER' },
  { label: 'Greater than or equal to', value: 'GREATER_OR_EQUAL' },
  { label: 'Less than', value: 'LESS' },
  { label: 'Less than or equal to', value: 'LESS_OR_EQUAL' }
]

interface Props {
  matrixOptions: IOption[]
}

const AppetiteOption: React.FC<WrappedFieldArrayProps<any> & Props> = ({ fields, matrixOptions }) => {
  const { showModal: showConfirmModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MATRIX_ITEM_MODAL })

  const addField = () =>
    fields.push({
      id: uuid(),
      message: null,
      color: colors.gray250,
      matrixOptionId: null,
      comparisonType: null
    })

  const removeField = (idx: number) => () => {
    showConfirmModal({
      entity: 'option',
      width: 'xs',
      handleConfirm: () => fields.remove(idx)
    })
  }

  return (
    <>
      <Scrollbar>
        {fields.map((field, idx) => {
          const option = fields.get(idx)

          return (
            <OptionWrapper key={field}>
              <SelectsWrapper>
                <ReduxSelect name={`${field}.comparisonType`} options={COMPARISON_OPTIONS} validate={[required]} />
                <ReduxSelect name={`${field}.matrixOptionId`} options={matrixOptions} validate={[required]} />
              </SelectsWrapper>
              <InputWrapper>
                <ReduxInput name={`${field}.message`} multiline />
              </InputWrapper>
              <ColorPickerWrapper>
                <ColorSelect
                  name={`${field}.color`}
                  initialColor={option.color}
                  trigger={<ColorWrapper color={option.color}>{option.color || 'set'}</ColorWrapper>}
                />
                <TrashIcon onClick={removeField(idx)} />
              </ColorPickerWrapper>
            </OptionWrapper>
          )
        })}
      </Scrollbar>

      <AddButton onClick={addField}>+ set appetite statement</AddButton>
    </>
  )
}

export default AppetiteOption
